export enum AvailabilityIngestionMutationsEnum {
  UpsertRecord = 'UPSERT_RECORD',
  UpsertRecords = 'UPSERT_RECORDS',
  SetListing = 'SET_LISTING',
  SetListingLoading = 'SET_LISTING_LOADING',
  SetListingError = 'SET_LISTING_ERROR',
}

export enum AvailabilityIngestionActionsEnum {
  FetchList = 'FETCH_LIST',
  FetchOne = 'FETCH_ONE',
  PatchExtraction = 'PATCH_EXTRACTION',
  Reject = 'REJECT',
  Approve = 'APPROVE',
}
